/*
 * @format
 */

import {
  delay,
  call,
  all,
  take,
  race,
  put,
  takeEvery,
} from 'redux-saga/effects';

import * as types from '../action-types';
import { Auth } from 'aws-amplify';
import jsonapi, { DSR } from '../api/jsonapi';
import Logger from '../../components/Logger';
import { GLOBAL_TIMEOUT } from '../utils/timeout';
import uuid from 'uuid/v4';

let jsonApi = null;
let abortController = null;

function* disableDsrRequest(homeId) {
  if (abortController) {
    abortController.abort();
  }

  abortController = new AbortController();

  return yield jsonApi.destroy(DSR, homeId, {
    opts: { signal: abortController.signal, timeout: GLOBAL_TIMEOUT },
  });
}

function* checkForResponse(homeId) {
  while (true) {
    yield take(action => {
      if (
        action.type === types.HOMES_MESSAGE_RECEIVED ||
        action.type === types.WEBSOCKET_LIVE_RECEIVED
      ) {
        const { data } = action;

        if (
          data?.home &&
          data.home.id === homeId &&
          (data.home?.hpi?.dsrEnabled === false ||
            data.home?.hpi?.DSREnabled === false)
        ) {
          return true;
        }
      }

      return false;
    });

    return;
  }
}

function* disableDsr(action) {
  const { homeId, callback } = action?.data;

  try {
    const response = yield call(disableDsrRequest, homeId);

    if (callback) {
      callback({ response });
    }
  } catch (err) {
    Logger.error('Error with API request when disabling DSR:', err);

    if (callback) {
      callback({ error: err });
    }

    return;
  }

  const requestId = uuid();

  // used to show the loading indicator
  yield put({
    type: types.DEVICE_SERVICE_REQUEST_STARTED,
    homeId,
    requestId,
    dsrEnabled: false,
  });

  const sixMinutesInMs = 6 * 60 * 1000;
  const { timeout } = yield race({
    response: all([
      take(types.WEBSOCKET_SET_DSR_STATUS_RECEIVED),
      call(checkForResponse, homeId),
    ]),
    timeout: delay(sixMinutesInMs),
  });

  if (timeout) {
    yield put({
      type: types.ENABLE_DSR,
      data: { homeId },
    });
  }

  // used to stop showing the loading indicator
  yield put({
    type: types.COMMAND_STATUS_ACK,
    requestId,
  });
  abortController = null;
}

function* dsr(params) {
  jsonApi = params?.jsonApi || jsonapi(Auth);

  yield takeEvery(types.DISABLE_DSR, disableDsr);
}

export default dsr;
